// "הופעה אחת" / "5 הופעות": Hebrew count phrases with the singular form for one
export const countLabel = (n: number, one: string, many: string): string =>
  n === 1 ? one : `${n.toLocaleString('he-IL')} ${many}`;

export const appearancesLabel = (n: number) => countLabel(n, 'הופעה אחת', 'הופעות');
